module.exports = __webpack_public_path__ + "static/img/1.19aa50c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/zh/1.png
// module id = yPzT
// module chunks = 0